var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserStarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6666V21.3333C11.5818 21.3333 8.00004 24.915 8.00004 29.3333H5.33337C5.33337 23.4422 10.109 18.6666 16 18.6666ZM16 17.3333C11.58 17.3333 8.00004 13.7533 8.00004 9.33325C8.00004 4.91325 11.58 1.33325 16 1.33325C20.42 1.33325 24 4.91325 24 9.33325C24 13.7533 20.42 17.3333 16 17.3333ZM16 14.6666C18.9467 14.6666 21.3334 12.2799 21.3334 9.33325C21.3334 6.38658 18.9467 3.99992 16 3.99992C13.0534 3.99992 10.6667 6.38658 10.6667 9.33325C10.6667 12.2799 13.0534 14.6666 16 14.6666ZM24 28.6666L20.0815 30.7267L20.8299 26.3632L17.6596 23.2731L22.0407 22.6366L24 18.6666L25.9594 22.6366L30.3404 23.2731L27.1702 26.3632L27.9186 30.7267L24 28.6666Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStarLine);
export default __webpack_public_path__ + "static/media/user-star-line.3ab40d3696411c92ba64b4a8e0a70c81.svg";
export { ForwardRef as ReactComponent };